<template>
    <a-card :bordered="false">
      <a-form-item><a @click="routeBack">&lt;&lt; 返回</a></a-form-item>
      <detail-list title="装卸货详情" v-if="mdl">
        <detail-list-item term="物流单号">{{ mdl.logisticsNo }}</detail-list-item>
        <detail-list-item term="车号">{{ mdl.vehicleNo }}</detail-list-item>
        <detail-list-item term="装卸货单号">{{ mdl.loadWehicleNo }}</detail-list-item>
        <detail-list-item term="类型">{{ mdl.typeName }}</detail-list-item>
        <detail-list-item term="货物名称">{{ mdl.materielName }}</detail-list-item>
        <detail-list-item term="装卸货点">{{ mdl.loadName }}</detail-list-item>
        <detail-list-item term="装卸货口">{{ mdl.loadPortCode }}</detail-list-item>
        <detail-list-item term="开始时间">{{mdl.startTime | formatDate}}</detail-list-item>
        <detail-list-item term="结束时间">{{mdl.endTime | formatDate}}</detail-list-item>
        <detail-list-item term="装卸车人">{{ mdl.loadUserName }}</detail-list-item>
        <detail-list-item term="补货（补包）数">{{ mdl.replenishCount }}</detail-list-item>
        <detail-list-item term="退货（退包）数">{{ mdl.quitCount }}</detail-list-item>
        <detail-list-item term="冲包数">{{ mdl.clashCount }}</detail-list-item>
        <detail-list-item term="装卸货量">{{ mdl.cargoQuantity }}</detail-list-item>
        <detail-list-item term="卸货扣杂">{{ mdl.deduct }}</detail-list-item>
      </detail-list>
    </a-card>
  </page-view>
</template>

<script>
import DetailList from '@/components/tools/DetailList'
import Moment from 'moment'
import storage from "@/utils/storage"


const DetailListItem = DetailList.Item

export default {
  components: {
    DetailList,
    DetailListItem
  },
  data () {
    return {
      mdl: null
    }
  },
  mounted () {
    this.initData()
  },
  filters: {
    formatDate (value) {
      return Moment(value).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  methods: {
    routeBack(){
      localStorage.setItem('goback', "true");
      this.$router.back(-1)
    },
    initData () {
      let cache = storage.fetch("cache-LoadVehicleDetail")
      if (cache){
          this.mdl = JSON.parse(cache);
      } 
    }
  }
}
</script>



